import React, { useEffect, useRef, useState } from 'react';

import refresh from './images/refresh.svg';
import audioOnImg from './images/audio-on.png';
import audioOffImg from './images/audio-off.png';

import Messages from '../../constants/Messages';
import Constants from '../../constants/Constants';

import SpeechUtil from '../../utilities/speech-utils';

import Loader from '../../components/loader/loader';
import TransactionItem from '../../components/transaction-item/transaction-item';
import SalesCard from './../../components/sales-card/sales-card';
import InlineMessageBlock from '../../components/inline-message-block/inline-message-block';

import TransactionService from '../../services/transaction-service';
import io from 'socket.io-client';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import AppRoutes from '../../constants/AppRoutes';
import AuthenticationService from '../../services/authentication-service';


/**
 * Container to show list of transactions 
 * @uses TransactionItem
 * @param {*} vendorId 
 * @returns 
 */
const Transactions = ({ vendorId, userRole }) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState();
    const [loader, setLoader] = useState(false);
    const [audioOn, setAudioOn] = useState(false);
    const audioRef = useRef();
    audioRef.current = audioOn;

    const navigate = useNavigate();
    const { authLogout } = useAuth(); 

    /** ----------------------------------------------
     * Method : toggleAudio
     * Description : Toggle Audio On and Off
     */
    const toggleAudio = () => {
        if(audioOn) {
            setAudioOn(false)
        } else {
            setAudioOn(true)
        }
    }

    /** ----------------------------------------------
     * Method : handleSocket
     * Description : connect to Socket
     */
    const handleSocket = () => {
        const socket = io();
        socket.on('connect', function () {
            // Connected, let's sign-up for to receive messages for this room
            socket.emit(Constants.SOCKET.EVENTS.VENDOR, vendorId);
        });
        
        socket.on(Constants.SOCKET.EVENTS.VENDOR_TRANSACTIONS, (data) => {
            speakOutLastTransaction(data.amount);
            getTransactions();
        });
    }

    /** ----------------------------------------------
     * Method : getTransactions
     * Description : To get transactions for vendor and employee
     */
    const getTransactions = async() => {
        setLoader(true);
        try{
            const response = await TransactionService.getTransactions();
            const usersEventDetails = await AuthenticationService.getEventDetails();
            if(userRole != Constants.USER_ROLES.VENDOR && !response.currentBalance.event && usersEventDetails)  navigate(AppRoutes.HOME);
            if(response.isSuccess) {
                const data = {
                    transactions : response?.transactions,
                    salesDetails : response?.salesDetails
                }
                setData(data);
            }
            setError(null);
        } catch (error) {
            if(error.code === Messages.ERROR_CODES.INVALID_JWT.code) {
                await authLogout();
                navigate(AppRoutes.LOGIN);
            } else {
                setError(error);
            }
        }
        setLoader(false);
    }

    /** ----------------------------------------------
     * Method : speakOutLastTransaction
     * Description : Read out the last transaction for vendor
     * @param {*} amount 
     * @param {*} name 
     */
    const speakOutLastTransaction = (amount) => {
        const text = `${Messages.TRANSACTIONS.MONEY_RECEIVED} ${amount}`;
        if(audioRef.current === true) {
            SpeechUtil.speak(text);
        }
    };

    useEffect(() => {
        (async () => {
            if(userRole === Constants.USER_ROLES.VENDOR) {
                handleSocket();
            }
            await getTransactions();
        })();
    }, []);

    return (
        <div className="p-4 pt-2">
            <>
                {
                    data && data.salesDetails ? (
                        <div className="flex grow w-full mb-2">
                            <SalesCard label = {Messages.TRANSACTIONS.SALES_SUMMARY.TODAY} value = {data.salesDetails.todaysSalesDetails.mrpItemsTotal + data.salesDetails.todaysSalesDetails.nonMrpItemsTotal}/>
                            <SalesCard label = {Messages.TRANSACTIONS.SALES_SUMMARY.MONTH} value = {data.salesDetails.thisMonthSalesDetails.mrpItemsTotal + data.salesDetails.thisMonthSalesDetails.nonMrpItemsTotal}/>
                            <div className = 'bg-red-500 flex flex-col rounded-lg' >
                                <div className='basis-1/2 flex items-center justify-center p-2 border-b cursor-pointer' onClick={getTransactions}>
                                    <img src = {refresh} className = 'w-6 ml-2 mr-2' alt = "Refresh"/>
                                </div>
                                <div className='basis-1/2 flex items-center justify-center p-2 cursor-pointer'  onClick={toggleAudio}>
                                    {
                                        audioOn ? <img src = {audioOnImg} className = 'w-6 ml-2 mr-2' alt = "Audio On"/> : <img src = {audioOffImg} className = 'w-6 ml-2 mr-2' alt = "Audio Off"/>
                                    }
                                </div>
                            </div>
                        </div>
                    ) : null
                }
                
                <h2 className='font-bold'>{Messages.TRANSACTIONS.TITLE}</h2>
                {
                    data &&
                    <div className='flex justify-between mb-4 text-xs'>
                    {
                        data?.transactions?.length === 50 ? 
                            <h3>{Messages.TRANSACTIONS.SHOWING_50}</h3>
                         : <h3>{Messages.TRANSACTIONS.SHOWING_ALL}</h3>
                    }
                    <div>{Messages.TRANSACTIONS.EVENT_CASH_LEGEND}</div>
                    </div>
                }

                {
                    data?.transactions ? data.transactions.map(item => <TransactionItem data = {item} key = {item.transactionId}/>
                    ) : ( loader ? null : <h2>{Messages.TRANSACTIONS.NO_TRANSACTIONS}</h2>)
                }
                {
                    data?.transactions?.length > 50 ? (
                        <h3 className='mt-4 text-xs'>{Messages.TRANSACTIONS.VIEW_MORE_HELP}</h3>
                    ) : <h3 className='mt-4 text-xs text-center'>{Messages.TRANSACTIONS.END_OF_TRANSACTIONS}</h3>
                }

                {
                    error ? <InlineMessageBlock 
                        title = {error.title} 
                        message = {error.message} 
                        subMessage = {error.subMessage}
                        actionCallback = {getTransactions}
                    /> : null
                }

                <Loader show = {loader}/>
            </>
        </div>
    )
}

export default Transactions;





